<template>
    <router-link :class="`block mx-${spacing} ${extraClassName}`" :to="link">
        <img src="/icons/actions/edit.svg" :class="`h-${size} w-${size} opacity-50 hover:opacity-100`" />
    </router-link>
</template>

<script>
    export default {
        props: {
            link: {
                type: Object,
                default: ''
            },
            size: {
                type: String,
                default: '4'
            },
            spacing: {
                type: String,
                default: '2'
            },
            extraClassName: {
                type: String,
                default: ''
            }
        },
    }
</script>